module.exports = __webpack_public_path__ + "media/images/brand-assets/screen-ee05f35a6db78d385eaae65402459ee9.png";